import { render, staticRenderFns } from "./XEmpty.vue?vue&type=template&id=95e31cbe&"
import script from "./XEmpty.vue?vue&type=script&lang=ts&"
export * from "./XEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../public-charging/admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports